import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        width: "100%",
        height: "9.12vw",
        backgroundColor: Color.Canvas
    },
    desktop: {
        width: "42vw",
        height: "2.47vw",
        backgroundColor: "transparent"
    }
};

export const VacancyCountLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }
    
    return (
        <div style={loaderStyles}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.LoaderForeground}
                foregroundColor={Color.LoaderForeground}
                width= "auto"
                height= {loaderStyles.height}
            > 
                {isMobile ? <>
                    <rect x="0%" y="0%" rx="8" ry="8" width="25.8%" height="85.1%" />
                    <rect x="31.2%" y="0%" rx="8" ry="8" width="27.6%" height="85.1%" />
                    <rect x="62%" y="0%" rx="8" ry="8" width="36.5%" height="85.1%" />
                </> : 
                <>
                    <rect x="0%" y="15%" rx="8" ry="8" width="9.74%" height="71.6%" />
                    <rect x="10.9%" y="15%" rx="8" ry="8" width="10.8%" height="71.6%" />
                    <rect x="23.1%" y="15%" rx="8" ry="8" width="14.1%" height="71.6%" />
                    <rect x="38.2%" y="15%" rx="8" ry="8" width="14.1%" height="71.6%" />
                    <rect x="53.3%" y="15%" rx="8" ry="8" width="15.1%" height="71.6%" />
                    <rect x="69.5%" y="15%" rx="8" ry="8" width="8.8%" height="71.6%" />
                </>}
            </ContentLoader>
        </div>
    );
}